<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <vendor-invoice v-if="content" :data="content" />
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import VendorInvoice from '@/components/lm-blocks/VendorInvoice'
import MilestoneMixin from '@/mixins/milestone.mixin'

import { get, cloneDeep, orderBy } from 'lodash'

export default {
  name: 'MilestoneApproveInvoices',
  components: { MilestoneWrapper, VendorInvoice },
  mixins: [MilestoneMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      email: null
    }
  },
  computed: {
    items() {
      let entries = cloneDeep(get(this, 'data.content'))
      return orderBy(entries, ['created_at'], ['desc'])
    }
  }
}
</script>
